<template>
  <div id="subscription-progress" class="container">
    <div class="row flex-center justify-content-between">
      <div class="progress">
        <div
          class="progress-bar progress-bar-striped progress-bar-animated"
          role="progressbar"
          :style="'width: ' + progress + '%;'"
          :aria-valuenow="progress"
          aria-valuemin="0"
          aria-valuemax="100"
        ></div>
      </div>
      <div class="placeholder"></div>
      <div class="step"><span>Event info</span></div>
      <div class="step"><span>Module info</span></div>
      <div class="step"><span>Subscription</span></div>
      <div class="step"><span>Overview</span></div>
      <div class="step"><span>Submitted</span></div>
    </div>
  </div>
</template>

<script>
export default {
  name: "StudyView",
  computed: {
    progress() {
      const routes = [
        "/",
        "/packages",
        "/subscribe/",
        "/subscribe/overview",
        "/subscribe/overview2"
      ];

      if (this.$store.state.subscriberData.Submitted) {
        return 100;
      }

      let current = 0;
      for (let i = 0; i < routes.length; ++i) {
        if (this.$route.path.startsWith(routes[i])) {
          current = i + 1;
        }
      }
      return (current / routes.length) * 100;
    }
  }
};
</script>

<style lang="scss">
@import "../assets/css/colors.scss";

#subscription-progress {
  margin-top: 16px;
  margin-bottom: 16px;
  
  .row {
    position: relative;
    height: 80px;

    .progress {
      position: absolute;
      left: 16px;
      right: 16px;
      height: 12px;
    }

    .progress-bar {
      background-color: $wvd-blue;
    }

    .placeholder {
      width: 32px;
      height: 32px;
    }

    .step {
      font-size: 14px;
      font-weight: 500;
      z-index: 100;
      width: 32px;
      height: 32px;
      background: $wvd-orange;
      border-radius: 50%;

      span {
        position: absolute;
        display: block;
        width: 128px;
        margin-left: -48px;
        top: 0;
        text-align: center;
      }
    }
  }
}
</style>